import React from 'react';
import { tx } from '@/translations/translations';

export const CartTotals = ({ language, subtotal, shipping, total, qualifiesFreeShipping }) => (
  <div className="border-t pt-3 space-y-2">
    <div className="flex justify-between text-sm text-slate-600">
      <span>{tx(language, 'Subtotal', 'Subtotal', 'סכום ביניים')}</span>
      <span>${subtotal.toFixed(2)} MXN</span>
    </div>
    <div className="flex justify-between text-sm text-slate-600">
      <span>{tx(language, 'Envío', 'Shipping', 'משלוח')}</span>
      {qualifiesFreeShipping ? (
        <span className="text-green-600 font-semibold">{tx(language, 'Gratis', 'Free', 'חינם')}</span>
      ) : (
        <span>${shipping.toFixed(2)} MXN</span>
      )}
    </div>
    <div className="flex justify-between items-baseline border-t pt-2">
      <span className="text-base font-bold text-slate-800">{tx(language, 'Total', 'Total', 'סה״כ')}</span>
      <span className="text-2xl font-black text-cyan-600">${total.toFixed(2)} <span className="text-xs text-cyan-600/70">MXN</span></span>
    </div>
  </div>
);
